import { type CreateSlice } from 'zustand-slice';

import { type CapturedUtm, type StoredUtm } from '@lib/utils/utm';

interface AttributionProperties {
    /**
     * Last-touch UTM attribution captured from an inbound URL (Braze email
     * links landing on /app-redirect, marketing share links). Persisted so it
     * survives reloads/restarts between the click and the order; sent with
     * the process-payment command and cleared after a successful order.
     */
    utm?: StoredUtm;
}

interface AttributionFunctions {
    setUtm: (utm: CapturedUtm) => void;
    clearUtm: VoidFunction;
    reset: VoidFunction;
}

export interface AttributionState extends AttributionProperties, AttributionFunctions {}

export type PersistedAttributionState = Pick<AttributionState, 'utm'>;

const DefaultState: AttributionProperties = {
    utm: undefined
};

export const initAttributionSlice: CreateSlice<AttributionState> = (set) => ({
    ...DefaultState,
    reset: () => set(DefaultState),
    setUtm: (utm: CapturedUtm) => set({ utm: { ...utm, capturedAt: new Date().toISOString() } }),
    clearUtm: () => set({ utm: undefined })
});
